export const PROFIL_JP_DOC = `**PT Jagad Pesona Buana** adalah perusahaan yang dibangun untuk menghadirkan sebuah **ekosistem terintegrasi**: produk, pengembangan diri, edukasi, dan peluang usaha dalam satu sistem.

**Berbasis di:**
📍 Green Lake City
Ruko Crown Blok E No. 21
Cipondoh – Tangerang
🌐 www.jpbuana.com
📧 ceojpbuana@jpbuana.com
📞 081776363738

**JP Buana** hadir dengan pendekatan yang mengikuti perkembangan zaman.
Tidak hanya menghadirkan produk dan peluang usaha, tetapi juga didukung oleh **sistem digital** yang memudahkan setiap mitra menjalankan aktivitas bisnis dari mana saja.

**Melalui platform terintegrasi**, JP Buana menggunakan:
📱 Aplikasi di Smartphone Android
🌐 Landing Page Digital
🤖 Chatbot Interaktif

Sehingga **informasi, promosi, pengembangan jaringan, dan komunikasi** dapat dilakukan dengan lebih praktis, cepat, dan efisien.

**Di dalam JP Buana, setiap orang dapat:**
✨ Menggunakan Produk yang Mendukung Kualitas Hidup
✨ Mengikuti Kelas dan Masterclass Pengembangan Diri
✨ Membangun Jaringan Usaha dengan Sistem Digital
✨ Bertumbuh Bersama Komunitas yang Saling Mendukung
✨ Memperoleh Workshop Menciptakan Realita Impian
✨ Mendapatkan Kesempatan Sertifikasi sebagai Praktisi International untuk Kelas:
🎓 B4Formats
🎓 Kuantum Oase
🎓 Communion Symbol

**JP Buana** dirancang sebagai **rumah pertumbuhan bersama** — tempat manfaat pribadi, kapasitas diri, dan peluang masa depan berjalan beriringan.`;

export const VISI_MISI_JP_DOC = `VISI
**Menjadi perusahaan penjual langsung yang terdepan** dengan dukungan **sistem digital terintegrasi**, sehingga setiap mitra dapat mengembangkan usaha secara fleksibel, modern, dan mengikuti perkembangan zaman.

**JP Buana dibangun dengan pemanfaatan teknologi melalui:**
📱 Aplikasi di Smartphone Android
🌐 Landing Page Digital
🤖 Chatbot Interaktif

Sehingga aktivitas pemasaran, edukasi, dan pengembangan jaringan dapat dilakukan dari mana saja, kapan saja, tanpa dibatasi lokasi dan keadaan.

MISI
Membangun komunitas sukses yang bertumbuh bersama melalui platform digital, produk berkualitas, edukasi, dan sistem yang membuka kesempatan bagi siapa saja untuk berkembang.

Sesuai tagline kami:
Your Success Community

JP Buana hadir untuk membantu setiap orang memiliki ruang untuk:
✨ Bertumbuh Secara Pribadi
✨ Berkembang Secara Finansial
✨ Membangun Relasi dan Komunitas Positif
✨ Memberi Kontribusi Nyata bagi Kemajuan Bersama

Kami percaya bahwa **pertumbuhan yang sehat** adalah pertumbuhan yang **seimbang** — secara fisik, mental, dan finansial.`;

export const FOUNDER_JP_DOC = `**JP Buana** dibangun dari perjalanan panjang, pengalaman nyata, dan pelajaran hidup yang tidak selalu mudah.

**Founder JP Buana** telah berkecimpung selama **belasan tahun** di dunia network marketing dan direct selling, dengan berbagai pencapaian terbaik yang pernah diraih dalam perjalanan tersebut.

Pada periode **2015 hingga 2020**, pernah dibangun sebuah perusahaan MLM sendiri yang berkembang serius hingga masuk dalam proses menuju **IPO (Go Public)**.
Sebuah langkah besar yang pada saat itu menjadi tonggak penting dalam perjalanan bisnis.

Namun ketika pandemi Covid melanda dunia, banyak hal berubah.
Arah besar yang sudah dibangun harus berhenti di tengah jalan.
Ada fase ketika semua yang telah dirancang harus menghadapi kenyataan yang tidak mudah.

Dalam setiap perjalanan besar, selalu ada titik di mana seseorang diuji:
Apakah berhenti, atau memilih bangkit dengan cara baru.

Dari titik itulah lahir keputusan penting:
Memulai kembali, tetapi bukan dengan cara lama.
Memulai dengan pendekatan yang lebih cerdas.
Lebih strategis.
Lebih efisien.
Lebih relevan dengan perkembangan teknologi hari ini.

Ada satu prinsip yang terus dipegang:
"Setiap pengalaman, termasuk yang tidak berjalan sesuai rencana, sesungguhnya sedang membentuk cara yang lebih matang untuk melangkah berikutnya."

Hari ini JP Buana hadir sebagai bentuk langkah baru:
✨ Dibangun dari Pengalaman
✨ Diperkuat oleh Pelajaran Hidup
✨ Didukung Sistem Digital
✨ Dirancang untuk Menjawab Kebutuhan Zaman

**JP Buana bukan dimulai dari nol.**
**JP Buana** dibangun dari **ketahanan, visi, dan keberanian** untuk membuka babak baru dengan cara yang lebih matang.`;

export const KEUNGGULAN_JP_DOC = `**JP Buana** dibangun sebagai sistem yang menggabungkan kebutuhan produk masa kini, dukungan teknologi digital, pengembangan diri, dan peluang usaha dalam **satu ekosistem terintegrasi**.

**Produk yang relevan dengan kebutuhan saat ini**
JP Buana memilih kategori produk yang dekat dengan kebutuhan masyarakat modern, sehingga lebih mudah digunakan, dipahami, dan dikembangkan pasarnya.
🌿 Wellness
📿 Wearable Technology
🛡 Preventive Lifestyle
⛽ Penghemat BBM

Kategori ini dipilih karena selaras dengan arah kebutuhan masyarakat yang semakin peduli pada kualitas hidup, efisiensi, dan solusi praktis sehari-hari.

**Sistem digital yang mengikuti perkembangan zaman**
JP Buana didukung dengan sistem digital yang memudahkan setiap mitra menjalankan aktivitas usaha secara modern:
📱 Aplikasi di Smartphone Android
🌐 Landing Page Digital
🤖 Chatbot Interaktif

Dengan sistem ini, informasi produk, edukasi, promosi, dan komunikasi dapat berjalan lebih cepat dan efisien.

**Produk, edukasi, dan bisnis dalam satu ekosistem**
Di JP Buana, pertumbuhan tidak hanya datang dari produk, tetapi juga dari **peningkatan kapasitas diri**.
**Setiap mitra memiliki akses pada:**
✨ Kelas Pengembangan Diri
✨ Masterclass
✨ Workshop Menciptakan Realita Impian
✨ Sertifikasi Praktisi International

**Untuk kelas:**
🎓 B4Formats
🎓 Kuantum Oase
🎓 Communion Symbol


**Komunitas yang bertumbuh bersama**
JP Buana dibangun dengan semangat **Your Success Community**.
Sebuah ruang di mana pertumbuhan dilakukan bersama, saling mendukung, dan berkembang dalam jaringan yang sehat.

**Reward system yang terstruktur**
Setiap pertumbuhan memiliki apresiasi melalui **sistem bonus dan reward** yang dirancang jelas.

**Founder support**
Founder hadir dengan pengalaman panjang di dunia network marketing dan direct selling, sehingga sistem dibangun dengan pendekatan yang **lebih matang, strategis, dan relevan** dengan kebutuhan zaman.

**JP Buana** dirancang agar setiap orang dapat berkembang dengan cara yang lebih cerdas, modern, dan memiliki **arah jangka panjang**.`;
